import React from "react";
import { dateFields, iconMap } from "./CamposParaIcones";
import { DataEHoraAmigavel } from "@/shared/utils/datas";

export default function HistoryIcon({ fieldNumber, value }: { fieldNumber: number; value: any }) {

  function formatValue(fieldNumber: number, value: any): string {
    if (dateFields.includes(fieldNumber))
      return DataEHoraAmigavel(value);

    if (fieldNumber === 8)
      return value ? 'Sim' : 'Não'; // Campo "ativo"

    if (typeof value === 'object' && value !== null)
      return value.username || JSON.stringify(value);
    
    return String(value ?? '');
  }

  const baseIcon = iconMap[fieldNumber] || iconMap[100];
  const fieldTitle = baseIcon.props.title;
  const formattedValue =
    fieldNumber === 100 ? 'Histórico vazio' : formatValue(fieldNumber, value);
  const fullTitle =
    fieldNumber === 100 ? fieldTitle : `${fieldTitle}: ${formattedValue}`;

  return React.cloneElement(baseIcon, { title: fullTitle });
}